import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMail, FiPhone, FiMapPin, FiInstagram, FiLinkedin, FiFacebook } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-purple-600 to-teal-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-poppins font-bold text-lg">CSA</span>
              </div>
              <div>
                <h3 className="font-poppins font-bold text-lg">Creative Solutions</h3>
                <p className="text-sm text-gray-400">Bringing Ideas to Life</p>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Transforming brands with creative excellence across South Africa and beyond. Your vision, our expertise.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-purple-600 transition-colors duration-200">
                <SafeIcon icon={FiInstagram} className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-purple-600 transition-colors duration-200">
                <SafeIcon icon={FiLinkedin} className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-purple-600 transition-colors duration-200">
                <SafeIcon icon={FiFacebook} className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-poppins font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-purple-600 transition-colors duration-200">About Us</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-purple-600 transition-colors duration-200">Services</Link></li>
              <li><Link to="/portfolio" className="text-gray-300 hover:text-purple-600 transition-colors duration-200">Portfolio</Link></li>
              <li><Link to="/process" className="text-gray-300 hover:text-purple-600 transition-colors duration-200">Process</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-purple-600 transition-colors duration-200">Blog</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-poppins font-semibold text-lg mb-4">Services</h4>
            <ul className="space-y-2">
              <li><Link to="/services/branding" className="text-gray-300 hover:text-purple-600 transition-colors duration-200">Branding & Identity</Link></li>
              <li><Link to="/services/web-design" className="text-gray-300 hover:text-purple-600 transition-colors duration-200">Web Design</Link></li>
              <li><Link to="/services/print-design" className="text-gray-300 hover:text-purple-600 transition-colors duration-200">Print Design</Link></li>
              <li><Link to="/services/digital-marketing" className="text-gray-300 hover:text-purple-600 transition-colors duration-200">Digital Marketing</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-poppins font-semibold text-lg mb-4">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <SafeIcon icon={FiMapPin} className="w-5 h-5 text-purple-600 mt-0.5" />
                <div className="text-gray-300 text-sm">
                  <p>Sandton City Office Park</p>
                  <p>Building 10, Suite 2004</p>
                  <p>Johannesburg, Gauteng</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="w-5 h-5 text-purple-600" />
                <span className="text-gray-300 text-sm">+27 11 234 5678</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="w-5 h-5 text-purple-600" />
                <span className="text-gray-300 text-sm">hello@cr8solu.co.za</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 Creative Solutions Agency. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-purple-600 text-sm transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-purple-600 text-sm transition-colors duration-200">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;